<template>
  <div class="float-wrapper">
    <template v-if="!$root._isEn">
      <!-- 飘窗 -->
      <div
        v-if="showFloat"
        class="notice-container"
        ref="floatWindow"
        :style="{ left: left + 'px', top: top + 'px' }"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <button class="notice-close" @click.stop="closeFloat">×</button>

        <div class="float-notice" @click="openModal">
          <p>关于新版国家统计局数据发布库上线的公告</p>
        </div>
      </div>

      <!-- 弹窗 -->
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <p style="font-size: 23px; text-align: center">关于新版国家统计局数据发布库上线的公告</p>

          <div class="notice-text">
            <p>
              为适应信息技术发展要求，进一步提升国家统计局数据发布库服务效能，更好满足社会各界对统计数据的需求，近期国家统计局数据发布库进行了升级优化，于3月27日正式推出新版国家统计局数据发布库（网址：https://data.stats.gov.cn/）。
            </p>
            <p>
              由于新系统上线仍有待实践检验，为此新版国家统计局数据发布库上线运行后将设置一段试运行期。试运行期间，请广大用户多提宝贵意见，我们将认真研究，不断完善数据发布库，努力提供更加优质的统计数据服务。
              <span style="font-weight: bold">如在使用过程中遇到任何问题或有改进建议，请于工作时间拨打010-68576320，或发送邮件至邮箱info@stats.gov.cn。</span>
            </p>
            <p>感谢社会各界长期以来对统计工作的关心与大力支持。</p>
          </div>

          <div class="notice-footer">
            国家统计局
            <br />
            2026年3月27日
          </div>

          <div class="btn-group">
            <!-- <a href="/files/20260311_关于新版国家统计局数据发布库上线的公告.wps" class="download-btn" download>下载公告文件</a> -->
            <button class="close-btn" @click="closeModal">关闭</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 飘窗 -->
      <div
        v-if="showFloat"
        class="notice-container notice-container-en"
        ref="floatWindow"
        :style="{ left: left + 'px', top: top + 'px' }"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <button class="notice-close" @click.stop="closeFloat">×</button>

        <div class="float-notice" @click="openModal">
          <p>Announcement on the Launch of the New Version of Database of the National Bureau of Statistics</p>
        </div>
      </div>

      <!-- 弹窗 -->
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content modal-content-en">
          <p style="font-size: 23px; text-align: center">Announcement on the Launch of the New Version of Database of the National Bureau of Statistics</p>

          <div class="notice-text notice-text-en">
            <p>
              To adapt to evolving demands of information technology, further improve service efficiency of the Database of the National Bureau of Statistics (NBS), and better meet the data needs of all sectors of society, the NBS Database has recently undergone upgrade and optimization. The new version (website: <span class="url-break">https://data.stats.gov.cn/</span>) is officially launched on March 27.
            </p>
            <p>
              As the new system requires practical testing, a trial operation period will be in place following the launch of the new version of Database. During this trial period, users are encouraged to provide valuable feedback. We will carefully review all suggestions and continuously improve the Database to deliver higher-quality statistical data services. If you encounter any issues or have suggestions for improvement during use, please call 010-68576320 during working hours or send emails to info@stats.gov.cn.
            </p>
            <p>We would like to express our gratitude to all sectors of society for the long-standing interest and strong support for statistical work.</p>
          </div>
          <div class="notice-footer">
            National Bureau of Statistics
            <br />
            March 27, 2026
          </div>

          <div class="btn-group">
            <!-- <a href="/files/20260311_关于新版国家统计局数据发布库上线的公告.wps" class="download-btn" download>下载公告文件</a> -->
            <button class="close-btn" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FloatNotice",

  data() {
    return {
      showFloat: true,
      showModal: false,

      // 位置
      left: 0,
      top: 0,

      // 速度
      speedX: 2,
      speedY: 1.5,

      isHover: false,
      animateId: null,

      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      floatWidth: 220,
      floatHeight: 120,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.floatWindow;
      if (el) {
        this.floatWidth = el.offsetWidth;
        this.floatHeight = el.offsetHeight;
      }

      // 初始位置
      this.left = this.windowWidth - this.floatWidth - 20;
      this.top = this.windowHeight * 0.2;

      this.startMove();
    });

    window.addEventListener("resize", this.handleResize);
    document.addEventListener("keydown", this.handleKeydown);
  },

  beforeDestroy() {
    cancelAnimationFrame(this.animateId);
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("keydown", this.handleKeydown);
  },

  methods: {
    startMove() {
      this.animateId = requestAnimationFrame(this.move);
    },

    move() {
      if (this.isHover || this.showModal || !this.showFloat) return;

      let left = this.left;
      let top = this.top;

      // 边界检测
      if (left <= 0 || left >= this.windowWidth - this.floatWidth) {
        this.speedX = -this.speedX;
      }
      if (top <= 0 || top >= this.windowHeight - this.floatHeight) {
        this.speedY = -this.speedY;
      }

      this.left += this.speedX;
      this.top += this.speedY;

      this.animateId = requestAnimationFrame(this.move);
    },

    handleMouseEnter() {
      this.isHover = true;
      cancelAnimationFrame(this.animateId);
    },

    handleMouseLeave() {
      this.isHover = false;
      if (!this.showModal) this.startMove();
    },

    openModal() {
      this.showModal = true;
      cancelAnimationFrame(this.animateId);
    },

    closeModal() {
      this.showModal = false;
      if (!this.isHover && this.showFloat) {
        this.startMove();
      }
    },

    closeFloat() {
      this.showFloat = false;
      cancelAnimationFrame(this.animateId);
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },

    handleKeydown(e) {
      if (e.key === "Escape" && this.showModal) {
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss">
.float-wrapper {
  .notice-container {
    position: fixed;
    z-index: 999;
    width: 220px;
    background: rgba(255, 255, 255, 0.8);
    border: 2px solid #005a9c;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .notice-close {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
    background: rgba(220, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
    transition: all 0.2s ease;
    z-index: 10; /* 按钮层级最高 */
  }
  .notice-close:hover {
    background: rgba(220, 0, 0, 1);
    transform: scale(1.1);
  }

  .float-notice {
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .float-notice:hover {
    background: rgba(240, 247, 255, 0.9);
  }
  .float-notice p {
    font-size: 15px;
    color: #005a9c;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
    word-wrap: break-word;
  }

  /* 英文版本飘窗样式 */
  .notice-container-en {
    width: 320px;
  }
  .notice-container-en .float-notice p {
    font-size: 14px;
    text-align: left;
    line-height: 1.6;
  }

  /* 弹窗 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-content {
    width: 600px;
    max-height: 800px;
    padding: 40px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    box-sizing: border-box;
  }
  /* 英文版本弹窗宽度更大 */
  .modal-content-en {
    width: 700px;
  }

  .modal-content h2 {
    color: #333;
    font-size: 20px;
    text-align: center;
    margin-bottom: 30px;
    font-weight: bold;
  }
  .modal-content .notice-text {
    color: #333;
    line-height: 1.8;
    font-size: 16px;
    text-align: justify;
    margin: 20px 0 40px 0;
    p {
      text-indent: 2em;
    }
  }
  /* 英文版本弹窗内容样式 - 避免两端对齐导致单词间距过大 */
  .modal-content .notice-text-en {
    text-align: left !important;
    word-break: keep-all;
    overflow-wrap: break-word;
    p {
      text-indent: 2em;
    }
    /* URL 允许在任意位置换行 */
    .url-break {
      word-break: break-all;
    }
  }
  .modal-content .notice-footer {
    text-align: right;
    font-size: 16px;
    margin-bottom: 30px;
  }
  /* 下载按钮样式 */
  .download-btn {
    display: inline-block;
    padding: 12px 30px;
    background: #005a9c;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    transition: background 0.2s ease;
    font-size: 16px;
    margin-right: 15px;
    box-sizing: border-box;
  }
  .download-btn:hover {
    background: #004070;
  }
  /* 关闭按钮 */
  .close-btn {
    padding: 12px 30px;
    background: #e0e0e0;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    box-sizing: border-box;
  }
  .close-btn:hover {
    background: #d0d0d0;
  }
  .btn-group {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
